var map = {
  "./assets/favicons-dev/android-chrome-192x192.png": "44143",
  "./assets/favicons-dev/android-chrome-512x512.png": "54087",
  "./assets/favicons-dev/apple-touch-icon-120x120.png": "75203",
  "./assets/favicons-dev/apple-touch-icon-152x152.png": "8247",
  "./assets/favicons-dev/apple-touch-icon-180x180.png": "75799",
  "./assets/favicons-dev/apple-touch-icon-60x60.png": "39915",
  "./assets/favicons-dev/apple-touch-icon-76x76.png": "95221",
  "./assets/favicons-dev/apple-touch-icon.png": "89864",
  "./assets/favicons-dev/browserconfig.xml": "1110",
  "./assets/favicons-dev/favicon-16x16.png": "63431",
  "./assets/favicons-dev/favicon-32x32.png": "69311",
  "./assets/favicons-dev/favicon-alert-16x16.png": "92026",
  "./assets/favicons-dev/favicon-alert-32x32.png": "32270",
  "./assets/favicons-dev/favicon-alert.ico": "8717",
  "./assets/favicons-dev/favicon.ico": "47008",
  "./assets/favicons-dev/mstile-144x144.png": "75095",
  "./assets/favicons-dev/mstile-150x150.png": "74643",
  "./assets/favicons-dev/mstile-310x150.png": "15165",
  "./assets/favicons-dev/mstile-310x310.png": "25079",
  "./assets/favicons-dev/mstile-70x70.png": "34201",
  "./assets/favicons-dev/safari-pinned-tab.svg": "99048",
  "./assets/favicons-dev/site.webmanifest": "64717",
  "./assets/favicons-dev/upc-favicon.ico": "89069"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 31708;
